import { cloneDeep } from "lodash";
import { FileDrop } from "react-file-drop";
import store from "../../stores/store";
import { useSelector } from "react-redux";
import { appInit, createNotification, trans } from "../../lib/utils";
import { removeMapAllLayers } from "../map/mapUtils";

function LoadConfiguration() {
  const layerTree = useSelector((state) => store.getState().layerTree);
  const layers = useSelector((state) => store.getState().layers);
  const registeredLayerTree = useSelector(
    (state) => store.getState().registeredLayerTree.tree
  );

  const replaceV3ConfigFunctions = [
    { '"fn_createPhotoAttribute"': "fn_createPhotoAttribute" },
    { '"fn_createBreakLinksAttribute"': "fn_createBreakLinksAttribute" },
    { '"fn_createLinkAttribute"': "fn_createLinkAttribute" },
    { '"fn_createAddDiagramAttribute"': "fn_createAddDiagramAttribute" },
    { '"rae_certificates_renderer"': "rae_certificates_renderer" },
    { '"hrakleio_addDiagToMapRenderer"': "hrakleio_addDiagToMapRenderer" },
    { '"hrakleio_diagLink"': "hrakleio_diagLink" },
    { '"fn_createBreakAttribute"': "fn_createBreakAttribute" },

    { name: "_attributeName" },
    { type: "_attributeType" },
    { title: "_attributeTranslation" },
    { value: "_attributeValue" },
    { editor: "_attributeEditor" },
    { sortable: "_attributeIsSortable" },
    { order: "_attributeOrder" },
    { isVisible: "_attributeIsVisible" },
    { searchable: "_attributeIsSearchable" },
    { isGeometry: "_attributeIsGeometry" },
    { visible: "_attributeVisible" },
    { geometryIsMulti: "_geometryIsMulti" },
    { onSummary: "_attributeShowOnSummary" },
    { included: "_attributeInclude" },
    { name: "_layerName" },
    { title: "_layerTitle" },
    { abstract: "_layerAbstract" },
    { singleTile: "_singleTile" },
    { searchable: "_isSearchable" },
    { nativeProjection: "_nativeSRS" },
    { checked: "_visibility" },
    { opacity: "_opacity" },
    { xy: "_xy" },
    { geometryField: "_geometryField" },
    { attributes: "_attributesFields" },
  ];
  async function FileToString(file) {
    return new Promise((resolve, reject) => {
      var fr = new FileReader();
      fr.onload = () => {
        resolve(fr.result);
      };
      fr.readAsText(file);
    });
  }

  return (
    <div className="mt-2">
      <label className="color-get-blue  mb-2">
        {trans("Select configuration file")}
      </label>
      <FileDrop
        onFrameDragEnter={(event) => {}}
        onFrameDragLeave={(event) => {}}
        onFrameDrop={(event) => {}}
        onDragOver={(event) => {}}
        onDragLeave={(event) => {}}
        onDrop={(files, event) => {
          if (Array.from(files).length > 1) {
            return;
          }

          Array.from(files).forEach(async (file) => {
            let config = await FileToString(file);

            if (config.indexOf("_config_load_layers") > 0) {
              replaceV3ConfigFunctions.forEach((el) => {
                config = config.replaceAll(
                  el[Object.keys(el)[0]],
                  Object.keys(el)[0]
                );
              });

              try {
                let groupConfig = config
                  .split("var _config_create_tree_groups=")[1]
                  .split("var _")[0];

                groupConfig = groupConfig.replaceAll("_groupId", "id");

                let layerConfig = config
                  .split("var _config_load_layers=")[1]
                  .split("var _")[0];

                layerConfig = layerConfig.replaceAll("_groupId_", "id_");

                let preLayers = [];

                JSON.parse(layerConfig).forEach((el) => {
                  el._perLayerProperties.forEach((preLayer) => {
                    let layerProperties = { ...preLayer };

                    layerProperties.source = {
                      url: el._serviceUrl,
                      type: el._serviceType,
                    };
                    layerProperties.visibility = preLayer.checked;

                    layerProperties?.attributes.forEach((attribute) => {
                      if (attribute?.renderer) {
                        attribute.editor = attribute.renderer;
                      }
                    });

                    preLayers.push({
                      id: preLayer.name,
                      title: preLayer.title,
                      type: "layer",
                      expanded: true,
                      checked: preLayer.checked,
                      layer: layerProperties,
                    });
                  });
                });

                function reccursive(data) {
                  return data?.map((el) => {
                    el.title = el.text;

                    if (el.type !== "layer") {
                      el.children = el.children.concat(
                        preLayers.filter((l) => {
                          return l.layer._groupId == el.id;
                        })
                      );
                      el.type = "group";
                    }

                    reccursive(el.children);

                    return el;
                  });
                }

                let newAppConfig = {};

                Object.keys(window["appConfig"]()).forEach((el) => {
                  if (el === "layerTree") {
                    newAppConfig[el] = reccursive(JSON.parse(groupConfig));
                  } else {
                    newAppConfig[el] = window["appConfig"]()[el];
                  }
                });

                window["appConfig"] = () => {
                  return { ...newAppConfig };
                };

                store.dispatch({
                  type: "loadconfiguration",
                  payload: { layerTree: window["appConfig"]()["layerTree"] },
                });

                appInit(
                  window["appConfig"]()["layerTree"],
                  registeredLayerTree
                );

                removeMapAllLayers();
                window["primaryModal"].setState({ show: false });
              } catch (e) {
                console.log(e);
                createNotification({
                  type: "danger",
                  message: trans(
                    "Could not load configuration. Please check file!"
                  ),
                });
              }
            }

            if (config.indexOf("appConfig") > 0) {
              try {
                let newAppConfig = {};

                Object.keys(window["appConfig"]()).forEach((el) => {
                  if (el !== "layerTree") {
                    newAppConfig[el] = window["appConfig"]()[el];
                  }
                });

                let layerTreeConfig = config
                  .split("layerTree:")[1]
                  .split("endLayerTree")[0];

                layerTreeConfig = layerTreeConfig.substring(
                  0,
                  layerTreeConfig.length - 1
                );

                newAppConfig["layerTree"] = JSON.parse(layerTreeConfig);

                window["appConfig"] = () => {
                  return { ...newAppConfig };
                };

                store.dispatch({
                  type: "loadconfiguration",
                  payload: { layerTree: newAppConfig["layerTree"] },
                });

                appInit(
                  window["appConfig"]()["layerTree"],
                  registeredLayerTree
                );

                removeMapAllLayers();

                window["primaryModal"].setState({ show: false });
              } catch (e) {
                createNotification({
                  type: "danger",
                  message: trans(
                    "Could not load configuration. Please check file!"
                  ),
                });
              }
            }
          });
        }}
      >
        <div className="w-100 text-center p-4 border">
          <span className="d-block mb-1">
            <strong>
              <span className="color-purple" role="button" onClick={() => {}}>
                {trans("Click here to upload")}
              </span>{" "}
              {trans("or drag and drop")}
            </strong>
          </span>
          <span className="color-grey d-block"></span>
        </div>
      </FileDrop>
    </div>
  );
}

export default LoadConfiguration;
